import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Button } from 'semantic-ui-react';

import { LoadingBase } from 'Components/';
import { Main, Filter } from 'Containers/';
import { EXPORT_TOTALS_FORM_NAME } from 'Common/FormEnum';
import { errorToast } from 'Common/ToastHelper';
import { ExportTotalsEnum } from 'Common/Constants/Enumeration/ExportTotalsEnum';
import { createToast, toastType } from 'Common/ToastHelper';

import * as ExportTotalsActions from './state/actions';
import * as ExportTotalsSelectors from './state/selectors';
import { ExportTotalsForm } from './ExportTotalsForm';

import 'Styles/pages/exporttotals/index.less';

class ExportTotals extends Component {
  path = '/exporttotals';

  componentDidMount() {
    const { getPage } = this.props;
    getPage();
  }

  componentDidUpdate(prevProps) {
    const { hasReport, setHasReport } = this.props;
    if (prevProps.hasReport === null && hasReport === false) {
      createToast(toastType.info, 'Results', 'No data found!', true);
    }
    setHasReport(null);

    if (errorToast(this.props, prevProps, 'fetchError')) {
      this.props.clearErrors();
    }
  }

  headerButtons = [
    {
      title: 'Chartwells',
      exportType: ExportTotalsEnum.Chartwells,
    },
  ];

  mainProps = {
    toolbox: {
      formName: EXPORT_TOTALS_FORM_NAME,
      shown: true,
      backButtonProps: {
        shown: false,
      },
      saveButtonProps: {
        content: 'Export',
      },
    },
    shouldNotUsePageWidth: true,
  };

  setSubPage = exportType => {
    const { setExportType } = this.props;
    setExportType(exportType);
  };

  render() {
    const { loading, exportData, exportType, ...rest } = this.props;
    const { mainProps, headerButtons, setSubPage } = this;

    return (
      <div className="export-totals-container">
        <Filter title="Export Totals" newRow={true}>
          <Grid.Row>
            <Grid.Column width={16}>
              <Button.Group
                basic
                className="btn-group--active-group"
                widths={headerButtons.length}
              >
                {headerButtons.map(button => (
                  <Button
                    key={button.title}
                    basic
                    disabled={loading}
                    className="white"
                    active={exportType === button.exportType}
                    onClick={() => setSubPage(button.exportType)}
                  >
                    {button.title}
                  </Button>
                ))}
              </Button.Group>
            </Grid.Column>
          </Grid.Row>
        </Filter>
        {loading && <LoadingBase />}
        <Main {...mainProps}>
          <ExportTotalsForm
            exportType={exportType}
            onSubmit={exportData}
            {...rest}
          />
        </Main>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: ExportTotalsSelectors.getFetching(state),
    fetchError: ExportTotalsSelectors.getFetchError(state),
    breakfastOptions: ExportTotalsSelectors.getBreakfastOptions(state),
    lunchOptions: ExportTotalsSelectors.getLunchOptions(state),
    exportType: ExportTotalsSelectors.getExportType(state),
    hasReport: ExportTotalsSelectors.getHasReport(state),
  };
};

const mapDispatchToProps = {
  getPage: ExportTotalsActions.getPage,
  exportData: ExportTotalsActions.exportData,
  setExportType: ExportTotalsActions.setExportType,
  setSelectedSiteIds: ExportTotalsActions.setSelectedSiteIds,
  clearErrors: ExportTotalsActions.clearErrors,
  setHasReport: ExportTotalsActions.setHasReport,
};

ExportTotals = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ExportTotals)
);

export { ExportTotals };



// WEBPACK FOOTER //
// ./src/pages/exporttotals/ExportTotals.js